import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type StatsigService from 'garaje/services/statsig';

export default class ActionItemTemplate extends Component<{
  header: string;
  headerInfo: string;
  subHeader: string;
  iconLink: string;
  iconAlt: string;
  pageLink: string;
  isUserLoggedIn: boolean;
  demoName: string;
  isDemoInstance: boolean;
}> {
  @service declare statsig: StatsigService;

  @action sendLinkClickEvent(): void {
    if (this.args.isUserLoggedIn) {
      window?.open(this.args.pageLink, '_blank');
      if (!this.args.isDemoInstance) {
        this.statsig.logEvent(`kiosk-demo-${this.args.demoName}-link-clicked`, this.args.header, {
          linkSrc: this.args.pageLink,
        });
      }
    }
  }

  <template>
    <div class="flex flex-col mb-8">
      {{#if @isUserLoggedIn}}
        <div class="flex flex-row cursor-pointer" {{on "click" this.sendLinkClickEvent}}>
          <div class="flex items-start gap-2">
            <span class="relative top-[-2px] min-w-[16px]">
              <img class="align-bottom" src={{@iconLink}} alt={{@iconAlt}} />
            </span>
            <div class="flex flex-col">
              <div class="text-carbon-60 font-bold text-sm">
                {{@header}}
              </div>
              <div class="text-carbon-60 pt-[4px] text-sm">
                {{@headerInfo}}
              </div>

              <div class="text-carbon-40 pt-[4px] text-sm">
                {{@subHeader}}
              </div>
            </div>
          </div>
          <div class="ml-auto min-w-[16px] max-w-[16px]">
            <img src="/assets/images/ipad-demo/icons/internal-link.svg" alt="open in new tab" />
          </div>
        </div>
      {{else}}
        <div class="flex flex-row">
          <div class="flex items-start gap-2">
            <span class="relative top-[-2px] min-w-[16px]">
              <img class="align-bottom" src={{@iconLink}} alt={{@iconAlt}} />
            </span>
            <div class="flex flex-col">
              <div class="text-carbon-60 font-bold">
                {{@header}}
              </div>
              <div class="text-carbon-60 pt-[4px]">
                {{@headerInfo}}
              </div>

              <div class="text-carbon-40 pt-[4px]">
                {{@subHeader}}
              </div>
            </div>
          </div>
        </div>
      {{/if}}
    </div>
  </template>
}
